var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "incomingManage" },
    [
      _c(
        "van-tabs",
        {
          attrs: { animated: "", sticky: "", type: "card" },
          model: {
            value: _vm.active,
            callback: function($$v) {
              _vm.active = $$v
            },
            expression: "active"
          }
        },
        [
          _c(
            "van-tab",
            { attrs: { title: "快递入库", name: "warehouse" } },
            [_c("keep-alive", [_c("warehouse")], 1)],
            1
          ),
          _c(
            "van-tab",
            { attrs: { title: "来料入库", name: "incoming" } },
            [_c("keep-alive", [_c("incoming")], 1)],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tabsRight" },
        [
          _c("span", { on: { click: _vm.rightClick } }, [_vm._v("来料统计")]),
          _c("van-icon", { attrs: { name: "arrow" } })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tabsLeftIcon", on: { click: _vm.back } },
        [_c("van-icon", { attrs: { name: "arrow-left" } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }